<template>
  <div class="footer">
    <div class="copyright" v-if="!tz">
      Copyright
      <a-icon type="copyright" /> 2023 <span></span>
    </div>
    <div class="copyright" v-if="tz">
      <span style="display:inline-block; margin-right: 4px;"> Copyright </span>
       <span> <a-icon type="copyright" /> GEKO FINANCE IT CENTER </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data () {
    return {
      tz:false
    }
  },
  created(){
    console.log(1,window.location.hostname)
    console.log(2,window.location.host)
    if(window.location.hostname.includes("allwfinancing")  || window.location.host.includes("allwfinancing")){
      this.tz=true
     
    }else{
      this.tz=false
    }
   
  }
}
</script>

<style lang="less" scoped>
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
